<template>
    <v-dialog v-model="show" fullscreen hide-overlay transition="dialog-bottom-transition">
        <v-card>
            <v-toolbar dark color="primary">
                <v-btn icon dark @click="close">
                <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-toolbar-title>Nuevo pedido</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn dark text @click="save">
                    Guardar
                </v-btn>
            </v-toolbar>
            <v-card>
                <v-card-subtitle>
                    <v-row>
                        <v-avatar>
                        <img
                            :src="user.avatar"
                        >
                        </v-avatar>
                        <v-select
                            label="Usuario"
                            v-model="user"
                            :items="users"
                        >
                        </v-select>
                        <v-btn icon @click="createUser">
                            <v-icon>mdi-account-plus</v-icon>
                        </v-btn>
                    </v-row>
                    <v-text-field
                        v-model="product"
                        :append-outer-icon="'mdi-plus'"
                        filled
                        label="Producto"
                        type="text"
                        @click:append-outer="addProduct"
                    >
                    </v-text-field>
                    <ProductsView v-bind:products="products"></ProductsView>
                </v-card-subtitle>
            </v-card>
        </v-card>
    </v-dialog>
</template>

<script>
/* eslint-disable */
import ProductsView from '../components/ProductsView'
import { DB } from '../firebase/db';

export default {
    name: 'create-order',

    data: () => ({
        products: [],
        product: '',
        show: false,
        date: '',
        user: {
            user: null,
            avatar: null
        },
        users: [],
        unsub: null
    }),

    components : {
      ProductsView
    },


    async created() {
        this.date = this.$route.params.date;

        this.unsub = DB.collection('users').onSnapshot( snapshots =>{
            this.users.splice(0)
            this.users = snapshots.docs.map( snapshot => {
                return {
                    text: snapshot.data().user,
                    value: snapshot.data()
                }
            })
        })
    },

    mounted() {
        this.show = true
    },

    methods: {
        close() {
            this.unsub()
            this.$router.go(-1)
        },

        addProduct() {
            if(this.product !== '') {
                this.products.push({name: this.product})
                this.product = ''
            }
        },

        async save() {
            let products = this.products;
            let location = null;
            let address = null;

            let snapshot = await DB.collection("users").doc(this.user.uid).get()
            if(snapshot) {
                location = snapshot.data().location
                address = snapshot.data().address
            }

            let ordersEntry = await DB.collection("orders")
                                      .where("uid", "==", this.user.uid)
                                      .where("date", "==", this.date)
                                      .where("isDelivered", "==", false)
                                      .get();
            if(!ordersEntry.empty) {
                console.log(ordersEntry)
                let oldProducts = ordersEntry.docs[0].data().products;

                products.forEach( (newProduct) => {
                    let result = oldProducts.find( value => {
                        return value.name === newProduct.name
                    })

                    if(!result) {
                        oldProducts.push(newProduct);
                    }
                });

                await DB.collection("orders")
                        .doc(ordersEntry.docs[0].id)
                        .update({products: oldProducts});
            }
            else {
                let order = {
                    user: this.user.user,
                    userPhoto: this.user.avatar,
                    uid: this.user.uid,
                    date: this.date,
                    creationDate: new Date(),
                    deliverDate: this.date,
                    products: products,
                    isDelivered: false,
                    location: location,
                    address: address
                }
                await DB.collection('orders').doc().set(order)
            }

            this.close()
        },

        createUser() {
            this.$router.push('/create-user')
        }
    }
}
</script>